module.exports = __webpack_public_path__ + "img/calendar4.a1124cb1.png";